import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n";
import { DICTS } from "@/i18n";
import { LANGS, pathFor } from "@/i18n/routes";

const SITE = process.env.REACT_APP_SITE_URL;

export default function Seo() {
  const { lang, t, pageKey } = useLang();
  const [title, description] = t.meta[pageKey] || t.meta.home;
  const base = SITE || window.location.origin;
  const isReal = pageKey !== "notFound";
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={t.locale} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {!isReal && <meta name="robots" content="noindex" />}
      {SITE && isReal && <link rel="canonical" href={`${SITE}${pathFor(lang, pageKey)}`} />}
      {SITE && isReal && <meta property="og:url" content={`${SITE}${pathFor(lang, pageKey)}`} />}
      {isReal && LANGS.map((l) => <link key={l} rel="alternate" hrefLang={l} href={`${base}${pathFor(l, pageKey)}`} />)}
      {isReal && <link rel="alternate" hrefLang="x-default" href={`${base}${pathFor("it", pageKey)}`} />}
      {LANGS.filter((l) => l !== lang).map((l) => <meta key={l} property="og:locale:alternate" content={DICTS[l].locale} />)}
    </Helmet>
  );
}
